import { c as _c } from "react/compiler-runtime";
import { HotelLastSecondHotelPagePropertiesTypes } from "@website/accommodation-ui/hotel-last-second/hotel-last-second-hotel-page/hotel-last-second-hotel-page.type";
import { HotelReserveCard } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card";
import { FC } from "react";
import { HotelLastSecondDiscountBox } from "../hotel-last-second-new-design";
export const HotelLastSecondHotelPage: FC<HotelLastSecondHotelPagePropertiesTypes> = t0 => {
  const $ = _c(17);
  const {
    lastSecondRooms,
    hasMorContentButton,
    roomDetail,
    onInView,
    snappPayData
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== hasMorContentButton || $[1] !== lastSecondRooms || $[2] !== onInView || $[3] !== roomDetail || $[4] !== snappPayData) {
    const lastSecondRoomsData = lastSecondRooms?.map(_temp2);
    t3 = "bg-transparent-primary border-transparent-primary mt-12 flex flex-col gap-4 border-y p-6 lg:mt-[124px] xl:mx-6 xl:mt-[78px] xl:rounded-xl xl:border";
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <HotelLastSecondDiscountBox size="medium" />;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    t1 = "flex flex-col gap-6";
    t2 = lastSecondRoomsData?.map(room_0 => <HotelReserveCard key={room_0.id} {...room_0} hasMorContentButton={hasMorContentButton} onClick={room_0.onClick} onInView={inView => onInView?.(inView, room_0)} roomDetail={roomDetail} snappPayData={snappPayData} />);
    $[0] = hasMorContentButton;
    $[1] = lastSecondRooms;
    $[2] = onInView;
    $[3] = roomDetail;
    $[4] = snappPayData;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t2) {
    t5 = <div className={t1}>{t2}</div>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
    t6 = <div className={t3}>{t4}{t5}</div>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
function _temp(badge) {
  return badge.type !== "last_minute";
}
function _temp2(room) {
  return {
    ...room,
    regularBadges: room?.regularBadges?.filter(_temp) || []
  };
}